import { Box, Button, Stack, Typography } from "@mui/material";
import ModalContainer from "../ui-elements/modal-container";
import { CloseDrawerIcon, HandsFistIcon } from "../ui-elements/svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { PATH_DASHBOARD } from "../../routes/path";
import { useDispatch } from "react-redux";
import { getUrlPathId, isCurrentPath } from "../../utils/random-functions";
import { setRefresh_dashboard } from "../../store/contentSlice";

export const PostPetitionModal = ({
  open,
  modal_handler,
  onSubmit,
}: {
  open: boolean;
  modal_handler: () => void;
  onSubmit: () => void;
}) => {
  const navigate = useNavigate();

  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={() => {}}
    >
      <Box sx={{ background: "#fff", py: 2, px: 4, borderRadius: "16px" }}>
        <Stack direction={"row"} justifyContent={"end"}>
          <Button sx={{ minWidth: 10 }} onClick={modal_handler}>
            <CloseDrawerIcon />
          </Button>
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={"/assets/icons/onboarding/caution-icon.png"}
            style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
          />
          <Typography variant="h5" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
            Notice!
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            Your petition is about to be submitted for approval. Please ensure
            all details are accurate and meet the required standards before
            proceeding. Once submitted, it will be reviewed for publication.
            Double-check your content to increase the chances of approval.
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            my: 3,
            mx: "auto",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmit}
            startIcon={<HandsFistIcon />}
            sx={{
              mt: 2,
              borderRadius: "40px",
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export const SendPetitionModal = ({
  open,
  modal_handler,
  close_modal,
  set_page_default,
}: {
  open: boolean;
  modal_handler: () => void;
  close_modal: () => void;
  set_page_default: () => void;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const path = getUrlPathId(location.pathname);
  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={() => {}}
    >
      <Box sx={{ background: "#fff", py: 2, px: 4, borderRadius: "16px" }}>
        <Stack direction={"row"} justifyContent={"end"}>
          <Button sx={{ minWidth: 10 }} onClick={modal_handler}>
            <CloseDrawerIcon />
          </Button>
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={"/assets/icons/onboarding/notice-green.png"}
            style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
          />
          <Typography variant="h5" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
            Petition submitted
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            Your petition has been successfully submitted for review. Our team
            is currently reviewing it, and you will be notified once it's
            published. Thank you for taking action and making your voice heard!
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            my: 3,
            mx: "auto",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: 40,
              boxShadow: "none",
            }}
            onClick={() => {
              set_page_default();
              modal_handler();
              if (isCurrentPath(path, location)) {
                // reload dahboard page
                dispatch(setRefresh_dashboard(true));
                close_modal();
              } else {
                navigate(PATH_DASHBOARD.root);
                close_modal();
              }
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export const PostReportModal = ({
  open,
  modal_handler,
  onSubmit,
}: {
  open: boolean;
  modal_handler: () => void;
  onSubmit: () => void;
}) => {
  const navigate = useNavigate();

  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={() => {}}
    >
      <Box sx={{ background: "#fff", py: 2, px: 4, borderRadius: "16px" }}>
        <Stack direction={"row"} justifyContent={"end"}>
          <Button sx={{ minWidth: 10 }} onClick={modal_handler}>
            <CloseDrawerIcon />
          </Button>
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={"/assets/icons/onboarding/caution-icon.png"}
            style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
          />
          <Typography variant="h5" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
            Notice!
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            Your Report is about to be submitted for approval. Please ensure all
            details are accurate and meet the required standards before
            proceeding. Once submitted, it will be reviewed for publication.
            Double-check your content to increase the chances of approval.
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            my: 3,
            mx: "auto",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmit}
            startIcon={<HandsFistIcon />}
            sx={{
              mt: 2,
              borderRadius: "40px",
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export const SendReportModal = ({
  open,
  modal_handler,
  close_modal,
  set_page_default,
}: {
  open: boolean;
  close_modal: () => void;
  modal_handler: () => void;
  set_page_default: () => void;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const path = getUrlPathId(location.pathname);



  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={() => {}}
    >
      <Box sx={{ background: "#fff", py: 2, px: 4, borderRadius: "16px" }}>
        <Stack direction={"row"} justifyContent={"end"}>
          <Button sx={{ minWidth: 10 }} onClick={modal_handler}>
            <CloseDrawerIcon />
          </Button>
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={"/assets/icons/onboarding/notice-green.png"}
            style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
          />
          <Typography variant="h5" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
            Your Report has been submitted
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            Your Report has been successfully submitted for review. Our team is
            currently reviewing it, and you will be notified once it's
            published. Thank you for taking action and making your voice heard!
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            my: 3,
            mx: "auto",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: 40,
              boxShadow: "none",
            }}
            onClick={() => {
              set_page_default();
              modal_handler();

              if (isCurrentPath(path, location)) {
                
                close_modal();
              } else {
                navigate(PATH_DASHBOARD.root);
                close_modal();
              }
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};
